document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-countdown-section]').forEach(function (section) {
    var endDate = section.getAttribute('data-end-date');
    var endTime = section.getAttribute('data-end-time') || '23:59';

    if (!endDate) {
      return;
    }

    var dateParts = endDate.trim().split('-');
    var timeParts = endTime.trim().split(':');

    if (dateParts.length !== 3) {
      return;
    }

    var year = Number(dateParts[0]);
    var month = Number(dateParts[1]);
    var day = Number(dateParts[2]);
    var hours = Number(timeParts[0] || 0);
    var minutes = Number(timeParts[1] || 0);

    if (
      isNaN(year) ||
      isNaN(month) ||
      isNaN(day) ||
      isNaN(hours) ||
      isNaN(minutes)
    ) {
      return;
    }

    var endTimeStamp = new Date(
      year,
      month - 1,
      day,
      hours,
      minutes,
      0
    ).getTime();

    if (isNaN(endTimeStamp)) {
      return;
    }

    var countdown = section.querySelector('[data-countdown]');

    if (!countdown) {
      return;
    }

    var days = countdown.querySelector('[data-days]');
    var hoursElement = countdown.querySelector('[data-hours]');
    var minutesElement = countdown.querySelector('[data-minutes]');
    var secondsElement = countdown.querySelector('[data-seconds]');

    if (
      !days ||
      !hoursElement ||
      !minutesElement ||
      !secondsElement
    ) {
      return;
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function updateCountdown() {
      var distance = endTimeStamp - Date.now();

      if (distance <= 0) {
        days.textContent = '00';
        hoursElement.textContent = '00';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';

        return false;
      }

      var totalSeconds = Math.floor(distance / 1000);

      var remainingDays = Math.floor(
        totalSeconds / 86400
      );

      var remainingHours = Math.floor(
        (totalSeconds % 86400) / 3600
      );

      var remainingMinutes = Math.floor(
        (totalSeconds % 3600) / 60
      );

      var remainingSeconds =
        totalSeconds % 60;

      days.textContent = pad(
        remainingDays
      );

      hoursElement.textContent = pad(
        remainingHours
      );

      minutesElement.textContent = pad(
        remainingMinutes
      );

      secondsElement.textContent = pad(
        remainingSeconds
      );

      return true;
    }

    updateCountdown();

    var countdownInterval = setInterval(function () {
      var active = updateCountdown();

      if (!active) {
        clearInterval(countdownInterval);
      }
    }, 1000);
  });
});